<div
  class="fancy-navigator-wrapper"
  [ngClass]="{ show: showButton, 'hide--xs': !showButton }"
>
  <a [href]="link_url" [target]="link_target" class="fancy-navigator-btn">
    <span>{{ link_text }}</span>
    <i class="fas fa-arrow-right arrow"></i>
  </a>
</div>
